import React from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";

const StoreAccountPolicySettings = () => {
  return (
    <>
      <div className="hstack justify-content-between mb-2 pt-3 px-3 pb-1">
        <Form.Group>
          <h6 className="m-0 d-block">Account & Policy Settings</h6>
          <Form.Text style={{ fontSize: 12 }}>
            Configure customer accounts, privacy, and data retention policies.
          </Form.Text>
        </Form.Group>
        <Button size="sm">Save</Button>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 175px)" }}>
        <div className="px-3 pb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <Form.Group className="mb-2">
                <Row className="g-2">
                  <Col xs={12}>
                    <Form.Label className="m-0">Guest checkout</Form.Label>
                    <Form.Check
                      style={{ fontSize: 13 }}
                      type="checkbox"
                      id="guest-checkout-allow"
                      label="Allow customers to place orders without an account"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      type="checkbox"
                      id="guest-checkout-login"
                      label="Allow customers to log into an existing account during checkout"
                    />
                  </Col>
                  <Col xs={12} className="mt-2">
                    <Form.Label className="m-0">Account creation</Form.Label>
                    <Form.Check
                      style={{ fontSize: 13 }}
                      type="checkbox"
                      id="account-create-checkout"
                      label="Allow customers to create an account during checkout"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      type="checkbox"
                      id="account-create-myaccount"
                      label='Allow customers to create an account on the "My account" page'
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      type="checkbox"
                      id="account-create-username"
                      label="When creating an account, automatically generate a username from the customer’s email address"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      type="checkbox"
                      id="account-create-password"
                      label="When creating an account, automatically generate an account password"
                    />
                  </Col>
                  <Col xs={12} className="mt-2">
                    <Form.Label className="m-0">
                      Account erasure requests
                    </Form.Label>
                    <Form.Check
                      style={{ fontSize: 13 }}
                      type="checkbox"
                      id="erase-personal-data"
                      label="Remove personal data from orders"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      type="checkbox"
                      id="erase-downloads"
                      label="Remove access to downloads"
                    />
                  </Col>
                  <Col xs={12} className="mt-2">
                    <Form.Label className="m-0 d-block">Privacy policy</Form.Label>
                    <Form.Text style={{fontSize: 12}}>This section control the display of your website privacy policy. The privacy notices bellow will not show up unless a  privacy page is first set.</Form.Text>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Privacy page</Form.Label>
                    <Form.Select style={{ fontSize: 13 }}>
                      <option>Privacy Policy</option>
                      <option>Terms & Conditions</option>
                      <option>Custom Page</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12}>
                    <Form.Label className="m-0">
                      Registration privacy policy
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Your personal data will be used to support your experience..."
                    />
                  </Col>
                  <Col xs={12}>
                    <Form.Label className="m-0">
                      Checkout privacy policy
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Your personal data will be used to process your order..."
                    />
                  </Col>
                  <Col xs={12} className="mt-2">
                    <Form.Label className="m-0">
                      Personal data retention
                    </Form.Label>
                    <Form.Text style={{ fontSize: 12 }}>
                      Choose how long to retain personal data when it’s no
                      longer needed for processing. Leave blank to retain
                      indefinitely.
                    </Form.Text>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label className="m-0">
                      Retain inactive accounts
                    </Form.Label>
                    <InputGroup>
                      <Form.Control type="number" min={0} placeholder="N/A" />
                      <Form.Select style={{ fontSize: 13 }}>
                        <option>Months</option>
                        <option>Days</option>
                        <option>Years</option>
                      </Form.Select>
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label className="m-0">
                      Retain pending orders
                    </Form.Label>
                    <InputGroup>
                      <Form.Control type="number" min={0} placeholder="N/A" />
                      <Form.Select style={{ fontSize: 13 }}>
                        <option>Days</option>
                        <option>Months</option>
                        <option>Years</option>
                      </Form.Select>
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label className="m-0">
                      Retain failed orders
                    </Form.Label>
                    <InputGroup>
                      <Form.Control type="number" min={0} placeholder="N/A" />
                      <Form.Select style={{ fontSize: 13 }}>
                        <option>Days</option>
                        <option>Months</option>
                        <option>Years</option>
                      </Form.Select>
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label className="m-0">
                      Retain cancelled orders
                    </Form.Label>
                    <InputGroup>
                      <Form.Control type="number" min={0} placeholder="N/A" />
                      <Form.Select style={{ fontSize: 13 }}>
                        <option>Days</option>
                        <option>Months</option>
                        <option>Years</option>
                      </Form.Select>
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label className="m-0">
                      Retain completed orders
                    </Form.Label>
                    <InputGroup>
                      <Form.Control type="number" min={0} placeholder="N/A" />
                      <Form.Select style={{ fontSize: 13 }}>
                        <option>Months</option>
                        <option>Days</option>
                        <option>Years</option>
                      </Form.Select>
                    </InputGroup>
                  </Col>
                </Row>
              </Form.Group>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default StoreAccountPolicySettings;
